import React, { useState } from "react";
import * as XLSX from "xlsx";
import CrudService from "services/cruds-service";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const ImportExcel = ({ onUploadSuccess }) => {
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

    const handleClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // First sheet
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Excel → JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                // Send to backend
                const response = await CrudService.bulkCreateGlobalAgents(jsonData);

                if (Array.isArray(response)) {
                    setSnackbar({
                        open: true,
                        message: `✅ ${response.length} records successfully added.`,
                        severity: "success",
                    });
                } else if (response.message) {
                    setSnackbar({
                        open: true,
                        message: `ℹ️ ${response.message}`,
                        severity: "info",
                    });
                } else {
                    setSnackbar({
                        open: true,
                        message: "✅ Import completed successfully.",
                        severity: "success",
                    });
                }

                // refresh table
                if (onUploadSuccess) onUploadSuccess();
            } catch (err) {
                console.error("Excel import error:", err);
                setSnackbar({
                    open: true,
                    message: "❌ An error occurred during import.",
                    severity: "error",
                });
            }
        };
        reader.readAsArrayBuffer(file);
    };

    return (
        <div>
            <Button
                variant="outlined"
                size="small"
                component="label"
                style={{ color: "#1976d2", borderColor: "#1976d2" }}
            >
                Upload Excel
                <input type="file" accept=".xlsx, .xls" hidden onChange={handleFileUpload} />
            </Button>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    severity={snackbar.severity}
                    onClose={handleClose}
                >
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default ImportExcel;
